export const API_PARAMS = { page_size: 40, redesign: 1, with_providers: 1 }

export const MIN_SEARCH_LENGTH = 3
